export function isValidDate(value) {
  const date = new Date(value);
  return date instanceof Date && !isNaN(date);
}

export const roundDownToNearestHour = (date) => {
  date.setMinutes(0);
  date.setSeconds(0);
  date.setMilliseconds(0);
  return date;
};
